import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const CustomCursor = () => {
  const [enabled] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(pointer: fine)").matches
  );
  const [variant, setVariant] = useState("default");
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 260, damping: 24, mass: 0.6 });
  const ringY = useSpring(y, { stiffness: 260, damping: 24, mass: 0.6 });

  useEffect(() => {
    if (!enabled) return;
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const t = e.target.closest("[data-cursor], a, button");
      setVariant(t ? t.getAttribute("data-cursor") || "link" : "default");
    };
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [enabled, x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        data-testid="custom-cursor-dot"
        className="fixed top-0 left-0 z-[100] pointer-events-none w-1.5 h-1.5 rounded-full bg-brand-cyan"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
      />
      <motion.div
        data-testid="custom-cursor-ring"
        className="fixed top-0 left-0 z-[99] pointer-events-none rounded-full border border-white/60 mix-blend-difference flex items-center justify-center"
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
        animate={variant}
        variants={{
          default: { width: 36, height: 36, backgroundColor: "rgba(255,255,255,0)", borderColor: "rgba(255,255,255,0.6)" },
          link: { width: 64, height: 64, backgroundColor: "rgba(255,255,255,0.12)", borderColor: "rgba(255,255,255,0.9)" },
          view: { width: 92, height: 92, backgroundColor: "rgba(0,85,255,0.95)", borderColor: "rgba(0,85,255,0)" },
        }}
        transition={{ type: "spring", stiffness: 320, damping: 22 }}
      >
        {variant === "view" && (
          <span className="text-[10px] font-sora font-bold uppercase tracking-[0.25em] text-white select-none">
            View
          </span>
        )}
      </motion.div>
    </>
  );
};

export default CustomCursor;
